import * as React from 'react'
import { StoreProps } from '../../../services/stores/casting.store'
import { I18nService } from '../../../services/utils/i18n.service'
import LoadingComponent from '../../shared/loading.component'

const i18nScoped = new I18nService(require('./casting-suspend-while-realtime-loading.component.yml'))

export default function CastingSuspendWhileRealtimeLoadingComponent ({ store, children }: StoreProps & { children?: React.ReactNode }) {
  if (!store.isRealTime() || store.getRealTimeAvailabilities()) {
    return children
  } else {
    return <LoadingComponent message={ i18nScoped.t('loading_realtime') } align="center" />
  }
}
